/**
 * Adds `noopener noreferrer` to the `rel` of every `target="_blank"` anchor in a rich text
 * fragment, keeping any `rel` values already present.
 *
 * Story link HTML is authored in Squire and persisted verbatim, so links saved before the
 * editor started emitting these values are still in the stored block data and have to be
 * normalized as they are rendered.
 */
export function addNoopenerToBlankLinks(html: string): string {
  if (!html.includes('_blank')) {
    return html;
  }

  const parsed = new DOMParser().parseFromString(html, 'text/html');

  parsed.body.querySelectorAll('a[target="_blank"]').forEach((anchor) => {
    const rel = new Set((anchor.getAttribute('rel') ?? '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    rel.add('noreferrer');
    anchor.setAttribute('rel', [...rel].join(' '));
  });

  return parsed.body.innerHTML;
}
